/*
 * Proprietary and confidential | 2023 | SoundTalks NV
 */

// Import environment-specific configs from src/config
import * as srcDev from './dev';
import * as srcUat from './uat';
import * as srcProduction from './production';
import * as srcTesting from './testing';
import * as srcDemo from './demo';
import * as srcDemoChina from './demo_china';
import * as srcDemoStaging from './demo_staging';
import * as srcChina from './china';

// Import environment-specific configs from config/environments
import envDev from '../../config/environments/dev.js';
import envUat from '../../config/environments/uat.js';
import envProduction from '../../config/environments/production.js';
import envTesting from '../../config/environments/testing.js';
import envDemo from '../../config/environments/demo.js';
import envDemoChina from '../../config/environments/demo_china.js';
import envDemoStaging from '../../config/environments/demo_staging.js';
import envChina from '../../config/environments/china.js';

const env = process.env.PROJECT_ENV || 'dev';
let config;

// Merge configs based on environment
switch (env) {
  case 'uat':
    config = { ...srcUat, ...envUat };
    break;
  case 'production':
    config = { ...srcProduction, ...envProduction };
    break;
  case 'testing':
    config = { ...srcTesting, ...envTesting };
    break;
  case 'demo':
    config = { ...srcDemo, ...envDemo };
    break;
  case 'demo_china':
    config = { ...srcDemoChina, ...envDemoChina };
    break;
  case 'demo_staging':
    config = { ...srcDemoStaging, ...envDemoStaging };
    break;
  case 'china':
    config = { ...srcChina, ...envChina };
    break;
  default:
    config = { ...srcDev, ...envDev };
}

export const {
  i18nBackendLoadPath,
  isChinaConfig,
  baseURL,
  captchaKey,
  apkDownloadUrl,
  isDemo,
  reversedFullName,
  googleMapsKey,
  autoUpdate,
  baiduMap,
  enableSubscription,
  wechatAppId,
  cookie_first,
  adobe_analytics,
  hotjar,
  allowedDownloadDomains,
} = config;

export default config;
